<template>
  <v-container fluid>
    <v-row>
      <div class='header'>
        <h2>Цитирование сайта</h2>
      </div>

      <div class='horizontal-rule' />

      <v-card class='citation__text' tile v-for='lang in usingLanguagesForCitation()'>
        <v-tooltip right color='white'>
          <template v-slot:activator='{ on, attrs }'>
            <v-btn v-bind='attrs' v-on='on' icon @click='copyTextCitation(lang)'>
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span class='color-secondary font-weight-bold'>Скопировать для цитирования</span>
        </v-tooltip>
        {{ getTextOfSiteCitationByLanguage(lang) }}
      </v-card>
    </v-row>
  </v-container>
</template>

<script>

import { getTextOfSiteCitationByLanguage, usingLanguagesForCitationSite } from '@/services/citationSiteService';

export default {
  name: 'CitationPage',

  methods: {
    getTextOfSiteCitationByLanguage,
    usingLanguagesForCitation() {
      return usingLanguagesForCitationSite;
    },
    copyTextCitation(lang = 'RU') {
      try {
        navigator.clipboard.writeText(this.getTextOfSiteCitationByLanguage(lang));
      } catch (e) {
        throw e;
      }
    },
  },
};
</script>